import React, { useCallback } from "react";
import { ReserveFieldUsers } from "@/features/reserve/components/ReserveFieldUsers/ReserveFieldUsers";
import { useReserveForm } from "@/features/reserve/components/Reserve/ReserveFormProvider";
import { noParkingResource } from "@/features/reserve/utils/utils-reserve";

export const ReserveFormUsers: React.FC = () => {
  const { form, users, owner } = useReserveForm();

  const handleUserChange = useCallback(() => {
    form.setValue("parking_resource", noParkingResource);
  }, [form]);

  return (
    <ReserveFieldUsers
      single={true}
      form={form}
      defaultValue={owner?.id ? [owner.id] : users}
      errors={form.formState.errors}
      onAfterChange={handleUserChange}
    />
  );
};
